import system from './system'


let config = {
  // 动态创建路由
  createRouter({ menu, pages, title }, key) {
    // 定义路由及frame
    let route = { path: '/' + key, meta: { login: key }, component: (resolve) => require(['../views/' + key + '/frame/frame.vue'], resolve), redirect: '/' + key + '/index' }

    // 菜单页面
    route.children = menu.map(item => {
      return {
        path: item.url,
        meta: { title: item.title },
        children: item.children ? item.children.map(node => {
          return {
            path: node.url,
            meta: { title: node.title },
            component: (resolve) => require(['../views/' + key + '/' + item.url + '/' + node.url + '.vue'], resolve)
          }
        }) : null,
        component: (resolve) => require(['../views/' + key + '/' + (item.children ? item.frame ? item.url + '/frame' : 'frame/generalFrame' : item.url) + '.vue'], resolve)
      }
    })

    // 不在菜单里面的其它页面
    pages && pages.map(item => {
      if (item.url) {
        route.children.push({ path: item.url, meta: { title: item.title }, component: (resolve) => require(['../views/' + key + '/' + item.url + '.vue'], resolve) })
      }
    })

    // 控制台首页
    route.children.push({ path: 'index', meta: { title: title }, component: (resolve) => require(['../views/' + key + '/frame/index.vue'], resolve) })

    return [route]
  },
  pattern: {
    // 邮件
    email: /^\+?[a-z0-9](([-+.]|[_]+)?[a-z0-9]+)*@([a-z0-9]+(\.|\-))+[a-z]{2,6}$/,
    // 密码; 1 可以全数字，2 可以全字母，3 可以全特殊字符(~!@#$%^&*.)，4 三种的组合，5 可以是任意两种的组合，6 长度6-22
    pass: /^[\@A-Za-z0-9\!\#\$\%\^\&\*\.\~]{6,22}$/,
    // 验证码
    sms: /^\d{4}$/,
    // 公司名称
    companyName: /^[\(\)\（\）\u4E00-\u9FA5]+$/,
    // 信用代码
    uscc: /^[1-9A-GY]{1}[1239]{1}[1-5]{1}[0-9]{5}[0-9A-Z]{10}$/,
    // 身份证
    card: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
    // 手机号（支持手机号码，3-4位区号，7-8位直播号码，1－4位分机号）
    phone: /^(\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$/,
    // 全数字
    number: /^[0-9]*$/,
    // 数字或小数
    number2: /^[0-9]+\.{0,1}[0-9]{0,2}$/,
    // 用户名
    regName: /^[a-zA-z][a-zA-Z0-9_]{3,16}$/,
    // 手机号
    mobile: /^1[34578]\d{9}$/

  }
}
export { config, system }